import { FormikValues } from 'formik';

import { Stringified } from 'modules/accommodations/features/tasks/models';

export const parseParams = <T>(searchParams: URLSearchParams): Stringified<T> => {
  const params: Record<string, any> = {};

  // Collect parameters and group repeated keys into arrays
  for (const [key, value] of Array.from(searchParams.entries())) {
    if (params[key]) {
      // If the key already exists, accumulate values in an array
      params[key] = Array.isArray(params[key]) ? [...params[key], value] : [params[key], value];
    } else {
      params[key] = value;
    }
  }

  return params as Stringified<T>;
};

export const convertToAxiosParams = (values: FormikValues, isOrderByParam?: boolean) => {
  return Object.keys(values).reduce((acc: FormikValues, key: string) => {
    if (values[key] && !isOrderByParam) {
      acc[`EqualsTo[${key}]`] = values[key];
    } else if (values[key] && isOrderByParam) {
      acc[`OrderBy[${key}]`] = values[key];
    }

    return acc;
  }, {});
};

export const objectToSearchParams = (
  obj: Record<string, any>,
  valuesForAcceptNull?: string[],
): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // For arrays, append each element with the same key (e.g., key=value1&key=value2)
      value.forEach(item => {
        if (item !== undefined && item !== null) {
          params.append(key, item.toString());
        }
      });
    } else if (value !== undefined && value !== null && value !== '') {
      // For other types, just append the key-value pair
      params.append(key, value.toString());
    } else if (valuesForAcceptNull && valuesForAcceptNull?.length > 0) {
      valuesForAcceptNull.forEach((keyNullValue: string) => {
        if (keyNullValue === key) {
          params.append(key, value);
        }
      });
    }
  });

  return params;
};

export const parseArray = (value: string | string[] | undefined): string[] => {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

export const parseNullableString = (value: string | undefined): string | null => {
  return value && value !== 'null' ? value : null;
};

export const parseNullableNumber = (value: string | number | undefined): number | null => {
  return value && typeof value === 'string'
    ? parseInt(value)
    : value && typeof value === 'number'
    ? value
    : null;
};
